const KEY = "stichb_alteration_draft";

function pickNumber(...values) {
  for (const value of values) {
    const number = Number(value);
    if (Number.isFinite(number)) return number;
  }
  return 0;
}

function normalizeServices(source = []) {
  const items = Array.isArray(source) ? source : [];

  return items.map((item) => {
    const policy = item?.pricingPolicy || {};
    const minimumPrice = pickNumber(
      item?.minimumPrice,
      item?.estimatedMinimum,
      item?.fixedPrice,
      item?.basePrice,
      item?.price,
      policy?.estimatedMinimum,
      policy?.fixedPrice,
      policy?.basePrice,
      policy?.minimumPrice,
    );
    const maximumPrice = pickNumber(
      item?.maximumPrice,
      item?.estimatedMaximum,
      item?.minimumPrice,
      item?.estimatedMinimum,
      item?.fixedPrice,
      item?.basePrice,
      item?.price,
      policy?.estimatedMaximum,
      policy?.estimatedMinimum,
      policy?.fixedPrice,
      policy?.maximumPrice,
    );

    return {
      ...item,
      id: item?.id || item?.serviceId || "",
      name: item?.name || item?.serviceName || "Alteration service",
      description: item?.description || item?.details || "",
      requiresMeasurements:
        item?.requiresMeasurements === true ||
        item?.requiresMeasurement === true ||
        false,
      requiresGarmentPhotos:
        item?.requiresGarmentPhotos === true ||
        item?.requiresPhotos === true ||
        false,
      pricingPolicy: policy,
      minimumPrice,
      maximumPrice,
    };
  });
}

export function normalizeAlterationDraft(raw = {}) {
  const source = raw && typeof raw === "object" ? raw : {};
  const legacyServices = Array.isArray(source.services)
    ? source.services
    : Array.isArray(source.selectedServices)
      ? source.selectedServices
      : [];
  const details = source.details && typeof source.details === "object"
    ? source.details
    : {};
  const pickup = source.pickup && typeof source.pickup === "object"
    ? source.pickup
    : {};
  const normalizedServices = normalizeServices(legacyServices);

  return {
    ...source,
    services: normalizedServices,
    selectedServices: normalizedServices,
    details: {
      ...details,
      measurements: details.measurements || {},
      photoNames: details.photoNames || details.garmentPhotoNames || [],
      photoUrls: details.photoUrls || details.garmentPhotoUrls || [],
      notes: details.notes || "",
    },
    pickup: { ...pickup },
    garment: source.garment || source.garmentDetails || null,
    updatedAt: new Date().toISOString(),
  };
}

export function readAlterationDraft() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(KEY) || "{}");
    return normalizeAlterationDraft(parsed);
  } catch {
    return normalizeAlterationDraft({});
  }
}

export function updateAlterationDraft(values) {
  const current = readAlterationDraft();
  const next = normalizeAlterationDraft({
    ...current,
    ...(values && typeof values === "object" ? values : {}),
    services: normalizeServices(
      Array.isArray(values?.services)
        ? values.services
        : Array.isArray(values?.selectedServices)
          ? values.selectedServices
          : current.services || []
    ),
    selectedServices: normalizeServices(
      Array.isArray(values?.selectedServices)
        ? values.selectedServices
        : Array.isArray(values?.services)
          ? values.services
          : current.selectedServices || []
    ),
    details: {
      ...(current.details || {}),
      ...(values?.details || {}),
      measurements: {
        ...((current.details || {}).measurements || {}),
        ...((values?.details || {}).measurements || {}),
      },
      photoNames: values?.details?.photoNames || values?.details?.garmentPhotoNames || (current.details || {}).photoNames || [],
      photoUrls: values?.details?.photoUrls || values?.details?.garmentPhotoUrls || (current.details || {}).photoUrls || [],
    },
    pickup: {
      ...(current.pickup || {}),
      ...(values?.pickup || {}),
    },
    updatedAt: new Date().toISOString(),
  });

  sessionStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function clearAlterationDraft() {
  const draft = normalizeAlterationDraft({});
  sessionStorage.setItem(KEY, JSON.stringify(draft));
  return draft;
}
